import moment, { unitOfTime } from 'moment';
import { createContext, Dispatch, SetStateAction } from 'react';

export interface FilterRecentContextType {
  limit: number;
  afterDate: number | undefined;
}

export interface FilterRecentCtx {
  filterRecentContext: FilterRecentContextType;
  setFilterRecentContext: Dispatch<
    SetStateAction<FilterRecentCtx['filterRecentContext']>
  >;
}

export const getDefaultFilterRecent = () => {
  const afterDateRecent = window.sessionStorage.getItem('afterDateRecent');
  const unit = afterDateRecent || 'd';
  const amount = afterDateRecent ? (afterDateRecent === 'd' ? 7 : 1) : 14;
  const limit = Number(window.sessionStorage.getItem('limitRecent')) || 50;
  return {
    afterDate: moment()
      .subtract(amount, unit as unitOfTime.DurationConstructor)
      .set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      })
      .valueOf(),

    limit,
  };
};

const FilterRecentContext = createContext({
  filterRecentContext: getDefaultFilterRecent(),
  setFilterRecentContext: () => ({}),
} as FilterRecentCtx);

export default FilterRecentContext;
